import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { User } from '../models/user';
import { AuthService } from '../services/auth-service';
import { take } from 'rxjs';

@Directive({
  selector: '[appHasRoles]' 
})
export class HasRolesDirective implements OnInit{ 

  @Input() appHasRole : string[] = [];

  user : User | null = null;

  constructor(private viewContainerRef : ViewContainerRef
    , private templateRef : TemplateRef<any>
    , private authService : AuthService) {

      this.authService.currentUser$.pipe(take(1)).subscribe(user =>{
        this.user = user;
      })
     }

     ngOnInit(): void {
      if (!this.user?.roles || this.user == null) {
        this.viewContainerRef.clear();
        return;
      }
  
      if(this.user?.roles.some(r => this.appHasRole.includes(r))){
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
      else{
        this.viewContainerRef.clear();
      }
    }
  

}
